import { render, staticRenderFns } from "./VideoTypeSettingSubtitles.vue?vue&type=template&id=ef7b4f8a&"
import script from "./VideoTypeSettingSubtitles.vue?vue&type=script&lang=js&"
export * from "./VideoTypeSettingSubtitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports